import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { ArchiveStatsModels } from '@models/archive-stats.models';
import { UtilsV2Service } from './utils-v2.service';

@Injectable({ providedIn: 'root' })
export class ArchiveStatsService {

  constructor(
    private http: HttpClient,
    private utilsV2Service: UtilsV2Service,
  ) {
  }

  public getArchiveStats(filters: ArchiveStatsModels.RequestFilter, latestTs: number): Observable<ArchiveStatsModels.Document[]> {
    let params = new HttpParams();
    const dateRange = this.utilsV2Service.dateRangeToServerRequest(filters.dateRange);
    params = params.set('limit', ArchiveStatsModels.PAGE_LIMIT);

    if (dateRange.start && dateRange.end) {
      params = params.set('timestampStart', dateRange.start);
      params = params.set('timestampEnd', dateRange.end);
    }
    if (latestTs) {
      params = params.set('latestTs', latestTs);
    }
    if (filters.status?.length) {
      params = params.set('status', filters.status.join(','));
    }
    if (filters.orgId) {
      params = params.set('orgId', filters.orgId);
    }
    return this.http.get<ArchiveStatsModels.Document[]>(api.archiveStats.get, { params });
  }
}